
import React, { Component } from "react"
import { push } from "../Services/Analytics"
import "./RuleVote.scss"
import { handleVote } from "../Services/Storage"
import { apiURL } from "../Services/baseURL"
import { _sendVotes } from "../Services/Fetch/votes";
import CountUp, { startAnimation } from 'react-countup';

class RuleVote extends Component {
    constructor() {
        super();
        this.liveCalculate = this.liveCalculate.bind(this);
        this.clickToVote = this.clickToVote.bind(this);
        this.handleVoteClick = this.handleVoteClick.bind(this);
        this.state = {
            isVote: false,
            isBusy: false,
            Like: 0,
            Dislike: 0,
            Summary: 0
        }
    }
    async componentDidMount() {
        if (handleVote.get(`Vote_${this.props.ID}`)) {
            this.setState({
                isVote: true
            })
        }
        const data = this.props.votesData[this.props.index];
        this.setState({
            Like: data.VoteLike,
            Dislike: data.VoteDislike,
            Summary: data.VoteLike + data.VoteDislike
        })

        // this.ruleItemVote.addEventListener("click", this.handleVoteClick)
    }
    clickToVote(event) {
        if (this.state.isBusy) return;
        if (this.state.isVote) return;
        if (handleVote.get(`Vote_${this.props.ID}`)) return;
        const voteType = (event.target.className === "approve");
        this.setState({
            isVote: true,
            isBusy: true
        })
        push(`Rule_book ${voteType ? "Like" : "Dislike"}`, this.props.name.replace(/<(?:.|\n)*?>/gm, ''));
        _sendVotes(this.props.ID, voteType, () => this.setState({
            isBusy: false
        }))
        this.liveCalculate(voteType);
        startAnimation(this.voteApprove);
        startAnimation(this.voteDisaggree);
    }
    liveCalculate(_type) {
        if (_type == "Like") {
            this.setState({
                Like: this.state.Like + 1,
                Summary: this.state.Summary + 1
            })
        } else {
            this.setState({
                Dislike: this.state.Dislike + 1,
                Summary: this.state.Summary + 1
            })
        }
    }
    handleVoteClick(event) {
        // var parentEle = this.findParentBySelector(event.target, ".rule-item-vote");
        // .firstChild.click();
    }
    collectionHas(a, b) {
        for (var i = 0, len = a.length; i < len; i++) {
            if (a[i] == b) return true;
        }
        return false;
    }
    findParentBySelector(elm, selector) {
        var all = window.document.querySelectorAll(selector);
        var cur = elm.parentNode;
        while (cur && !this.collectionHas(all, cur)) {
            cur = cur.parentNode;
        }
        return cur;
    }
    render() {
        return (
            <div className="rule-item-vote" ref={ruleItemVote => this.ruleItemVote = ruleItemVote}>
                <div className={`votes ${this.state.isVote ? "active" : ""}`} onClick={this.clickToVote}>
                    <div className="approve">
                        <div className="text">
                            <CountUp
                                className="account-balance"
                                start={0}
                                end={Math.round(this.state.Like / this.state.Summary * 100)}
                                duration={5.75}
                                useEasing={true}
                                useGrouping={true}
                                prefix=""
                                suffix="%"
                                ref={voteApprove => this.voteApprove = voteApprove}
                            />
                        </div>
                    </div>
                    <div className="disagree">
                        <div className="text">
                            <CountUp
                                className="account-balance"
                                start={0}
                                end={Math.round(this.state.Dislike / this.state.Summary * 100)}
                                duration={5.75}
                                useEasing={true}
                                useGrouping={true}
                                prefix=""
                                suffix="%"
                                ref={voteDisaggree => this.voteDisaggree = voteDisaggree}
                            />
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default RuleVote;


// WEBPACK FOOTER //
// ./src/Components/Rules/RuleVote.jsx